import React, {useRef, useState} from 'react';
import Checkbox from 'components/Checkbox/Styled';
import {useDispatch} from 'react-redux';
import {createPost, deletePost, updateLabel} from 'actions/readerActions';
import TrashIcon from 'assets/svgs/actions/trash.svg';
import IconModal from 'components/IconModal';
import CheckIcon from 'assets/svgs/actions/confirm-delete-check.svg';
import ClearIcon from 'assets/svgs/actions/clear.svg';
import useScrollable from 'hooks/useScrollable';
import messages from '../messages';
import Row from './Row';

const PostTable = ({
  posts,
  basicUser,
  onRefresh,
  selected,
  setSelected,
  folders,
  labels,
  countries,
}) => {
  const dispatch = useDispatch();
  const table = useRef();
  useScrollable(table);
  const [deleteConfirm, setDeleteConfirm] = useState({
    isOpen: false,
    post: null,
  });

  const renderBody = () => (
    <tbody>
      {posts.map((post) => (
        <React.Fragment key={post._id}>
          <Row
            folders={folders}
            labels={labels}
            countries={countries}
            selected={selected.find((f) => f === post._id)}
            onCheckboxChange={() => {
              let newSelected = [...selected];
              if (selected.find((f) => f === post._id)) {
                newSelected = newSelected.filter((f) => f !== post._id);
              } else {
                newSelected.push(post._id);
              }
              setSelected(newSelected);
            }}
            basicUser={basicUser}
            post={post}
            onDelete={(newPost) =>
              setDeleteConfirm({isOpen: true, post: newPost})
            }
            onUpdateLabel={(label) => {
              dispatch(updateLabel(label));
            }}
            onUpdate={(oldPost) => {
              const newPost = {
                ...oldPost,
                companyId: oldPost.companyId._id,
              };

              dispatch(createPost(newPost));

              setTimeout(() => {
                onRefresh();
              }, 1000);
            }}
          />
        </React.Fragment>
      ))}
    </tbody>
  );

  const renderHeader = () => (
    <thead>
      <tr>
        <th style={{minWidth: 4}} className="p-0 left-border-class"></th>
        <th
          width="80px"
          style={{minWidth: 80}}
          className="bg-white text-center"
        >
          <Checkbox
            className="bg-gray"
            checked={selected.length === posts.length}
            handleChange={() => {
              if (selected.length === posts.length) {
                setSelected([]);
              } else {
                setSelected(posts.map((p) => p._id));
              }
            }}
          />
        </th>
        <th width="80px" className="post-img bg-white text-uppercase">
          {messages.images}
        </th>
        <th
          width="80px"
          style={{minWidth: 80}}
          className="bg-white text-uppercase"
        ></th>
        <th
          style={{minWidth: 200, maxWidth: 236}}
          className="bg-white text-uppercase"
        >
          {messages.postName}
        </th>
        <th style={{minWidth: 100}} className="text-uppercase">
          {messages.added}
        </th>
        <th style={{minWidth: 200}} className="text-uppercase">
          {messages.notes}
        </th>

        <th style={{minWidth: 100}} className="text-center text-uppercase">
          {messages.folders}
        </th>
        <th style={{minWidth: 84}} className="text-uppercase">
          {messages.label}
        </th>
        <th style={{minWidth: 80}} className="text-right text-uppercase">
          {messages.postEdit}
        </th>
      </tr>
    </thead>
  );

  return (
    <div className="mt-4 post-list reader-posts-list">
      <IconModal
        isOpened={deleteConfirm.isOpen}
        Icon={TrashIcon}
        body={
          <div className="d-flex flex-column">
            {deleteConfirm.post && (
              <>
                {deleteConfirm.post.isTrashed ? (
                  <>
                    <p className="mb-0 font-12">
                      This post will be removed permanently,
                    </p>
                    <p>Are you sure you want to delete it?</p>
                  </>
                ) : (
                  <>
                    <p className="mb-0 font-12">
                      This post will be moved to trash,
                    </p>
                    <p>Are you sure you want to delete it?</p>
                  </>
                )}
              </>
            )}

            <div className="d-flex justify-content-between w-100">
              <button
                type="button"
                className="cat-delete"
                onClick={() => setDeleteConfirm({isOpen: false})}
              >
                <img src={ClearIcon} alt="" className="mr-2" />
                Cancel
              </button>
              <button
                type="button"
                className="ml-auto cat-delete"
                onClick={() => {
                  const newPost = {...deleteConfirm.post};
                  if (!newPost.isTrashed) {
                    newPost.companyId = newPost.companyId._id;
                    newPost.isTrashed = true;
                    dispatch(createPost(newPost));
                    onRefresh();
                  } else {
                    dispatch(deletePost(newPost._id));
                    onRefresh();
                  }

                  setDeleteConfirm({isOpen: false});
                }}
              >
                <img src={CheckIcon} alt="" className="mr-2" />
                Confirm
              </button>
            </div>
          </div>
        }
        onClose={() => {
          setDeleteConfirm(false);
        }}
      />
      <table className="table" ref={table}>
        {renderHeader()}
        {renderBody()}
      </table>
    </div>
  );
};

export default PostTable;
